// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"flag-2"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M8 14V3H4V14H8Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M13 16H20L18 10.5L20 5H13L11 3H8V14H11L13 16Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4 3H11L13 5H20L18 10.5L20 16H13L11 14H4M4 3V14M4 3H8V14H4M4 14V21.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-flag-2')
export default class Flag2Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'flag-2',
    }
  }
}
